<template>
  <div
    v-if="show"
    role="alert"
  >
    <slot />
    <button @click="onClose">
      <bg-icon
        name="close"
        size="xs"
      />
    </button>
  </div>
</template>

<script setup>
import checkpointResource from '@/commons/resources/checkpoint';
import { BgIcon } from '@transfeeradev/bridge';
import { ref } from 'vue';

const props = defineProps({
  checkpoint: {
    type: String,
    required: true
  }
});

const show = ref(false);

const onClose = () => {
  checkpointResource.create(props.checkpoint);
  show.value = false;
};

checkpointResource.exists(props.checkpoint).then(result => {
  if (result) {
    show.value = !result?.exists;
  }
});
</script>

<style scoped>
[role='alert'] {
  position: relative;
  padding: 16px 32px;
  background: var(--bg-blue-light);
  border: 1px solid #ebeff2;

  button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
  }
}
</style>
